const nameEl = document.getElementById('detail-name');
const avatarEl = document.getElementById('contact-avatar');

function refreshAvatar(): void {
  if (!nameEl || !avatarEl) return;

  const name = (nameEl.textContent || '').trim();
  if (!name) return;

  const parts = name.split(/\s+/).filter(Boolean);
  avatarEl.textContent =
    parts.length >= 2
      ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
      : name.slice(0, 2).toUpperCase();
}

if (nameEl) {
  new MutationObserver(refreshAvatar).observe(nameEl, {
    childList: true,
    characterData: true,
    subtree: true
  });
}

const contactList = document.getElementById('contact-list');
const emptyState = document.getElementById('empty-state');

function syncEmpty(): void {
  if (!contactList || !emptyState) return;
  emptyState.style.display = contactList.querySelector('.contact-item') ? 'none' : 'flex';
}

if (contactList) {
  new MutationObserver(syncEmpty).observe(contactList, { childList: true });
  syncEmpty();
}

/* Attention tagging (needs-attention class + tag) is computed in
   renderContactList() from the stored interaction dates — re-parsing
   formatted date text here was unreliable across locales. */

const interList = document.getElementById('interaction-list');
const timelineEmpty = document.getElementById('timeline-empty');

function syncTimeline(): void {
  if (!interList || !timelineEmpty) return;
  timelineEmpty.style.display = interList.children.length === 0 ? 'block' : 'none';
}

if (interList) {
  new MutationObserver(syncTimeline).observe(interList, { childList: true });
  syncTimeline();
}
